import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import BiltyCompanyDetails from './BiltyCompanyDetails';
import BiltyConsignorConsignee from './BiltyConsignorConsignee';
import BiltyLoadAndTripDetails from './BiltyLoadAndTripDetails';
import BiltyInsuranceSignature from './BiltyInsuranceSignature';
import { addElr, editElr, biltyContinueClick, getElrInfo, getTripDetailsV3,getJourneyDetails } from '../../../../store/actions/tripActionCreator';
import * as logger from '../../../../logger';
import BiltyTimeline from '../BiltyTimeline';
import BiltyReportPreview from '../../../components/BiltyDialogs/BiltyReportPreview';
import BiltyReportView from '../../../components/Dialog/JourneyBiltyReportView';

const BiltyFlow = ({ open, onClose, trip,selectedTrip,selectedLr,journey,updateJourney, user, biltyTimeLineValue, pdfPreviewValue, dispatchAddElr, dispatchEditElr, dispatchBiltyContinueClick, dispatchGetElrInfo, dispatchTripDetailsAction }) => {

    let submit;
    let journeyId = journey && journey.id?journey.id:'';
    let tripId = selectedTrip && selectedTrip.id ? selectedTrip.id : "";
    // let elrId = user && user.singleTripData && user.singleTripData.elr_id ? user.singleTripData.elr_id : "";
    let elrStatus = selectedLr && selectedLr.status ? selectedLr.status : "";

    const [dialogOpen, setDialogOpen] = useState(open);
    const [waterMarkValue, setWaterMarkValue] = useState(false);
    const [elrData, setElrData] = useState({});
    const [steps, setSteps] = useState(1);
    const [biltyTitle, setBiltyTitle] = useState("Company Details");
    const [barType, setBarType] = useState("");
    const [companyDetailsFlag, setCompanyDetailsFlag] = useState(false);
    const [congineeConsignorData, setCongineeConsignorData] = useState({});
    const [loadAndTripData, setLoadAndTripData] = useState({});
    const [insuranceSignatureData, setInsuranceSignatureData] = useState({});
    const [showBiltyTimeLine, setShowBiltyTimeLine] = useState(biltyTimeLineValue);
    const [showBiltyPdf, setShowBiltyPdf] = useState(pdfPreviewValue);
    const [checkAllStatusTrue, setCheckAllStatusTrue] = useState(false);
    const [elrId, setElrId] = useState("");

    useEffect(() => {

        if (user && user.singleTripData && user.singleTripData.id && selectedLr &&  selectedLr.id) {
            setElrId(selectedLr.id)
        }

    }, [user.singleTripData])

    useEffect(() => {

        if (trip && trip.elrLoadData && trip.elrLoadData.company_details) {
            setElrData(trip.elrLoadData.company_details)
        }

    }, [trip.elrLoadData]);

    useEffect(() => {

        if (steps == 1) {
            setBiltyTitle("Company Details");
            setBarType("biltyCompanyDetails");
            setCompanyDetailsFlag(true);
        } else if (steps == 2) {
            setBiltyTitle("LR & Consignor Consignee Details");
            setBarType("biltyConsignorConsignee");
            setCompanyDetailsFlag(false);
        } else if (steps == 3) {
            setBiltyTitle("Load & Trip Details");
            setBarType("biltyConsignorConsignee");
            setCompanyDetailsFlag(false);
        } else if (steps == 4) {
            setBiltyTitle("Insurance & Signature");
            setBarType("biltyConsignorConsignee");
            setCompanyDetailsFlag(false);
        }

    }, [steps]);

    useEffect(() => {

        if (biltyTimeLineValue) {
            setBiltyTitle("Online Bilty (LR)");
            setBarType("biltyTimeLine");
            setCompanyDetailsFlag(false);
        }

    }, [biltyTimeLineValue])


    const handleBackClick = (value) => {

        trip.materialList = [];

        dispatchGetElrInfo(elrId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Bilty Flow Dweb", "Get Elr Info Successfull");
                    if (value >= 25) {
                        setSteps((value / 25) - 1);
                    }
                }
            },
            () => {
                logger.log("Bilty Flow Dweb", "Get Elr Info Failed");
            }
        );
    }

    const handleContinueClick = (value) => {

        trip.materialList = [];

        dispatchBiltyContinueClick(false);

        if ((value - 25) == 25) {

            const companyDetailsData = {
                trip_id: tripId,
                company_details: {
                    address_line_1: elrData.address_line_1 ? elrData.address_line_1 : "",
                    address_line_2: elrData.address_line_2 ? elrData.address_line_2 : "",
                    contact_number: elrData.contact_number ? elrData.contact_number.replace("-", "") : "",
                    email: elrData.email ? elrData.email : "",
                    gst_number: elrData.gst_number ? (elrData.gst_number).toUpperCase() : "",
                    name: elrData.name ? elrData.name : "",
                    pan_number: elrData.pan_number ? (elrData.pan_number).toUpperCase() : "",
                    pincode: elrData.pincode ? elrData.pincode : "",
                    state: elrData.state ? elrData.state : "",
                    logo_link: elrData.logo_link ? elrData.logo_link : ""
                },
                use_watermark: waterMarkValue
            }

            if (elrId) {

                dispatchEditElr(elrId, companyDetailsData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('BiltyFlow Dweb', 'Edit ELR successfull');
                            dispatchTripDetailsAction(journeyId, (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    if (value <= 100) {
                                        setSteps(value / 25);
                                    }
                                }
                            },
                                () => {

                                }
                            );
                        }
                    },
                    () => {
                        logger.log('BiltyFlow Dweb', 'Edit ELR failed');
                    }
                );

            } else {
                dispatchAddElr(companyDetailsData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log('BiltyFlow Dweb', 'Add ELR Successfull');
                            dispatchTripDetailsAction(journeyId, (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    if (value <= 100) {
                                        setSteps(value / 25);
                                    }
                                }
                            },
                                () => {

                                }
                            );
                        }
                    },
                    () => {
                        logger.log('BiltyFlow Dweb', 'Add ELR Failed');
                    }
                )
            }

        } else if ((value - 25) == 50) {

            dispatchEditElr(elrId, congineeConsignorData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('BiltyFlow Dweb', 'Edit ELR successfull');
                        dispatchGetElrInfo(elrId,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log('Bilty Home Dweb', 'Get ELR info successfull');
                                    if (value <= 100) {
                                        setSteps(value / 25);
                                    }
                                }
                            },
                            () => {
                                logger.log('Bilty Home Dweb', 'Get ELR info failed');
                            }
                        )
                    }
                },
                () => {
                    logger.log('BiltyFlow Dweb', 'Edit ELR failed');
                }
            );

        } else if ((value - 25) == 75) {

            dispatchEditElr(elrId, loadAndTripData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('BiltyFlow Dweb', 'Edit ELR successfull');
                        dispatchGetElrInfo(elrId,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log('Bilty Home Dweb', 'Get ELR info successfull');
                                    if (value <= 100) {
                                        setSteps(value / 25);
                                    }
                                }
                            },
                            () => {
                                logger.log('Bilty Home Dweb', 'Get ELR info failed');
                            }
                        )
                    }
                },
                () => {
                    logger.log('BiltyFlow Dweb', 'Edit ELR failed');
                }
            );

        } else if ((value - 25) == 100) {
            dispatchEditElr(elrId, insuranceSignatureData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('BiltyFlow Dweb', 'Edit ELR successfull');
                        dispatchGetElrInfo(elrId,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log('Bilty Home Dweb', 'Get ELR info successfull');
                                    setShowBiltyTimeLine(true);
                                    setBiltyTitle("Online Bilty (LR)");
                                    setBarType("biltyTimeLine");
                                }
                            },
                            () => {
                                logger.log('Bilty Home Dweb', 'Get ELR info failed');
                            }
                        )
                    }
                },
                () => {
                    logger.log('BiltyFlow Dweb', 'Edit ELR failed');
                }
            );

        }

    }

    const handleClose = () => {
        trip.singleConsignee = {};
        trip.singleConsignor = {};
        setDialogOpen(false);
        onClose();
        dispatchBiltyContinueClick(false);
    }

    const handleWaterMarkValue = value => {
        setWaterMarkValue(value);
    }

    const handleConsignorConsigneeData = value => {
        setCongineeConsignorData(value);
    }

    const handleLoadAndTripDetailsData = value => {
        setLoadAndTripData(value);
    }

    const handleBiltyInsuranceSignatureData = value => {
        setInsuranceSignatureData(value);
    }

    const handleStepCount = (stepValue) => {
        setSteps(stepValue);
        setShowBiltyTimeLine(false);
    }

    const handlePreviewBilty = () => {
        trip.congineePdf = {};
        trip.consignorPdf = {};
        setShowBiltyPdf(true);
    }

    const handleReportClose = () => {
        setShowBiltyPdf(false);
        setDialogOpen(false);
        setDialogOpen(false);
        onClose();
    }

    const handleEdit = () => {
        setShowBiltyPdf(false);

        setTimeout(() => {
            setShowBiltyTimeLine(true);
            setDialogOpen(true);
            setBiltyTitle("Online Bilty (LR)");
            setBarType("biltyTimeLine");
        }, 70)

    }

    const handleAllTrue = value => {
        setCheckAllStatusTrue(value)
    }

    return (
        <>
            {!showBiltyPdf &&
                <>
                    { dialogOpen && <RightSideBar
                        sideBarName="online-bilty"
                        rightSideBarOpen={dialogOpen}
                        sideBarTitle={biltyTitle}   // Company Details, LR & Consignor Consignee Details  
                        sideBarType={barType} // biltyCompanyDetails, biltyConsignorConsignee
                        titleType="biltyFlow"
                        fromBiltyFlow={true}
                        handleSubmit={event => submit(event)}
                        continueClick={handleContinueClick}
                        backClick={handleBackClick}
                        toggleRightSideBar={handleClose}
                        dividerNotRequired={true}
                        fromBiltyCompanyDetails={companyDetailsFlag}
                        biltyTimeLine={showBiltyTimeLine}
                        previewBilty={handlePreviewBilty}
                        stepCountValue={steps}
                        checkAllTrueBiltyFlow={checkAllStatusTrue}
                    >

                        {!showBiltyTimeLine &&
                            <>

                                {steps == 1 &&
                                    <BiltyCompanyDetails journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} watermarkValue={handleWaterMarkValue} open={true} />
                                }


                                {steps == 2 &&
                                    <BiltyConsignorConsignee journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} onDataPopulated={handleConsignorConsigneeData} />
                                }

                                {steps == 3 &&
                                    <BiltyLoadAndTripDetails journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} open={true} onDataPopulated={handleLoadAndTripDetailsData} />
                                }

                                {steps == 4 &&
                                    <BiltyInsuranceSignature journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} onDataPopulated={handleBiltyInsuranceSignatureData} />
                                }

                            </>
                        }

                        {showBiltyTimeLine &&
                            <BiltyTimeline journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} onStepSelect={handleStepCount} open={true} onCheck={handleAllTrue} />
                        }


                    </RightSideBar>}
                </>
            }
            {showBiltyPdf &&
                <BiltyReportView journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} open={showBiltyPdf} onClose={handleReportClose} onEdit={handleEdit} />
            }

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchAddElr: (companyDetailsData, onSuccess, onError) => {
        dispatch(addElr(companyDetailsData, onSuccess, onError))
    },
    dispatchEditElr: (elrId, details, onSuccess, onError) => {
        dispatch(editElr(elrId, details, onSuccess, onError))
    },
    dispatchGetElrInfo: (elrId, onSuccess, onError) => {
        dispatch(getElrInfo(elrId, onSuccess, onError))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getJourneyDetails(tripId, onSuccess, onError))
    },
    dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyFlow);